import { UtilHelper } from '../../../../shared/helpers/utils.helper';
import { ReceivableStatus } from '../enums/receivable-status.enum';

export class Receivable {
  total: number;
  status: ReceivableStatus;
  orderId: number;
  orderDate: string;
  customerName: string;
  totalToReceive: string;
  estimatedPaymentDate: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, ReceivableStatus);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/receivables/legacy/models/receivable.model.ts